/**
 * @file remove-variants.tsx
 * @module app/modals/remove-variants
 * @description Renders the remove variants modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Button, Col, Modal, Row, Form } from 'react-bootstrap';
import CrossSvg from '../../_admin/assets/media/close.png';
import { error } from '../../Global/toast';
import { useEffect, useState } from 'react';

const RemoveVariants = (props: any) => {
  const [selectedVariants, setSelectedVariants] = useState<Set<any>>(() => {
    const temp = new Set()
    props.generalData.combinations.forEach((value: any, index: any) => {
      if(value._id)
      {
        temp.add(index)
      }
    }
  )
  return temp
  });

  const allSelected = selectedVariants.size === props?.generalData?.combinations?.length;
  useEffect(() => {
    if (props.show && props.generalData.selectedCheckedNewValue?.length) {
      const selectedIndices = new Set(
        props.generalData.combinations
          .map((item: any, index: number) =>
            props.generalData.selectedCheckedNewValue.some((selectedItem: any) => selectedItem.title === item.title) ? index : null
          )
          .filter((index: number | null) => index !== null) as number[]
      );
      setSelectedVariants(selectedIndices);
    }
  }, [props.show, props.generalData.selectedCheckedNewValue, props.generalData.combinations]);

  const handleCheckboxChange = (index: number) => {
    setSelectedVariants((prev) => {
      const updated = new Set(prev);
      if (updated.has(index)) {
        updated.delete(index);
      } else {
        updated.add(index);
      }
      return updated;
    });
  };

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedVariants(new Set());
    } else {
      setSelectedVariants(new Set(props.generalData.combinations.map((_: any, index: number) => index)));
    }
  };

  const handleNext = () => {
    const filteredCombinations = props.generalData.combinations.filter((_: any, index: any) =>
      selectedVariants.has(index)
    );
    if (filteredCombinations.length > 0) {
      props.onNextTab(1, { ...props.generalData, combinations: filteredCombinations, selectedCheckedNewValue: filteredCombinations }, props.validation);
    } else {
      error('Please select at least one variant ');
    }
  };

  console.log(props.generalData)
  return (
    <>
      <Modal
        {...props}
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-dialog-centered min-w-lg-600px"
        size="xl"
        className="border-r10px"
        centered
        backdrop="static"
      >
        <Modal.Header className="border-bottom-0 pb-0 text-center mx-auto">
          <img
            className="close-inner-top"
            width={40}
            height={40}
            src={CrossSvg}
            alt="closebutton"
            onClick={props.onHide}
          />
          <Modal.Title className="fs-26 fw-bolder mw-lg-375px pt-lg-3">
            Select Variants
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="text-center mt-8">
            <div className="mh-350px overflow-y-scroll border border-r10px p-4">
              {props?.generalData?.combinations?.length ? (
                <>
                  <div className="container-fluid mb-3">
                    <Row>
                      <Col lg={12} className="d-flex align-items-center">
                        <Col lg={1} className="text-left">
                          <Form.Check
                            type="checkbox"
                            checked={allSelected}
                            onChange={handleSelectAll}
                          />
                        </Col>
                        <Col lg={10}>
                          <span className="fs-20 fw-600 text-left">Select All</span>
                        </Col>
                      </Col>
                    </Row>
                  </div>
                  {props.generalData.combinations.map((item: any, index: number) => (
                    <div key={index} className="container-fluid">
                      <Row>
                        <Col lg={12} className="d-flex mb-5 mt-5 m-auto align-items-center">
                          <Col lg={1} className="text-left">
                            <Form.Check
                              type="checkbox"
                              checked={selectedVariants.has(index)}
                              onChange={() => handleCheckboxChange(index)}
                            />
                          </Col>
                          <Col lg={10}>
                            <div className="d-flex fs-20 fw-600 text-left">
                              <span className="d-inline-block breakWord-nextLine">
                                {item.title}
                              </span>
                            </div>
                          </Col>
                          {props.generalData.combinations[index]._id ? (
                            <Col lg={1}></Col>
                          ) : (
                            <Col lg={1}>
                              <div className="d-flex align-items-start">
                                <span className="badge bg-e5f6de border-r4px p-3 fs-14 fw-600 text-dark me-2">
                                  New
                                </span>
                              </div>
                            </Col>
                          )}
                        </Col>
                      </Row>
                      {index !== props.generalData.combinations.length - 1 && (
                        <div className="separator border"></div>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="mt-10">
              <Button className="uw-btn uw-btn-primary" onClick={handleNext}>Next</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default RemoveVariants;
